import {VERSION} from './version';

export const environment = {
  development: false,
  staging: false,
  production: false,
  systemtest: false,
  VERSION,
  machineKEY:'apiToken123a45r6tjna%etdrha$',
  apiUrl: 'https://sq3devbackend.albert-ing.com/not-implemented/api', //44309
  projectsApi: 'https://sq3devbackend.albert-ing.com/Projects/api/projects', //44353
  projectroles:'https://sq3devbackend.albert-ing.com/Projects/api/roles', //44382
  projectGroupRolePermissions:'https://sq3devbackend.albert-ing.com/Projects/api/projectgrouprolepermissions',
  projectGroupRoles:'https://sq3devbackend.albert-ing.com/Projects/api/projectgrouproles',//44382
  groupRolePermissions:'https://sq3devbackend.albert-ing.com/Projects/api/grouprolespermissions',//44382

  modelsApi: 'https://sq3devbackend.albert-ing.com/not-implemented/api/models', //44396
  revisionsApi: 'https://sq3devbackend.albert-ing.com/not-implemented/api', //44357
  apiUrlRevisions: 'https://sq3devbackend.albert-ing.com/not-implemented/api', //44357  
    
  account: 'https://sq3devbackend.albert-ing.com/Users/api/accounts', //44369
  userProfile:'https://sq3devbackend.albert-ing.com/Users/api/userprofile', //44369
  userPermissions:'https://sq3devbackend.albert-ing.com/Users/api/userpermissions', //44369
  permissions:'https://sq3devbackend.albert-ing.com/Users/api/permissions',
  groupRoles:'https://sq3devbackend.albert-ing.com/Users/api/grouproles',
  platformGroupRoles: 'https://sq3devbackend.albert-ing.com/Users/api/platformgrouproles',
  identityApi:'https://sq3devbackend.albert-ing.com/Users/api/identity', //44369
  identityAccount:'https://sq3devbackend.albert-ing.com/IdentitySTS/account', //44310
  identityAdmin:'https://sq3devbackend.albert-ing.com/IdentitySTS', //44303
  
  genericDocuments:'https://sq3devbackend.albert-ing.com/Documents/api/genericdocuments', //44342
  documents:'https://sq3devbackend.albert-ing.com/Documents/api/documents', //44342
  valueConfPage:'https://sq3devbackend.albert-ing.com/Documents/api/valueconfpage', //44342
  valueConfAttribute:'https://sq3devbackend.albert-ing.com/Documents/api/valueconfattribute', //44342
  attributeValue:'https://sq3devbackend.albert-ing.com/Documents/api/attributevalue', //44342
  statusColor:'https://sq3devbackend.albert-ing.com/Documents/api/statuscolor', //44342

  databaseMigrations:'https://sq3devbackend.albert-ing.com/DbMigrations/api/databaseupdates',//44368

  tenants:'https://sq3devbackend.albert-ing.com/Tenants/api/tenants', //44379
  tenantProjects:'https://sq3devbackend.albert-ing.com/Tenants/api/projects', //44379
  tenantUsers:'https://sq3devbackend.albert-ing.com/Tenants/api/users', //44379
  tenantProjectGroupRoles:'https://sq3devbackend.albert-ing.com/Tenants/api/projectgrouproles', //44379
  tenantGroupRolePermissions:'https://sq3devbackend.albert-ing.com/Tenants/api/grouprolespermissions', //44379
  tenantProjectRoles:'https://sq3devbackend.albert-ing.com/Tenants/api/projectroles', //44379
  tenantProjectGroupRolePermissions:'https://sq3devbackend.albert-ing.com/Tenants/api/projectgrouprolepermissions', //44379
  tenantplatformGroupRoles:'https://sq3devbackend.albert-ing.com/Tenants/api/platformgrouproles', //44379
  tenantpermissions:'https://sq3devbackend.albert-ing.com/Tenants/api/permissions', //44379
  tenantgrouproles:'https://sq3devbackend.albert-ing.com/Tenants/api/tenantgrouproles', //44379
  tenantapplicationtokens:'https://sq3devbackend.albert-ing.com/Tenants/api/tokenservice', //44379
  tenantaudit:'https://sq3devbackend.albert-ing.com/Tenants/api/auditservice', //44379
  tenantfiles: 'https://sq3devbackend.albert-ing.com/Tenants/api/file', //44379

  projecturl:'https://projectdev.squirrel-cde.de',

  
  // legacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
  // legacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',

  //------- Dev-Server --------------------------------------------------------------------------------------

  sq3devLegacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
  sq3devLegacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',

  //--------------------------------------------------------------------------------------------------------

   //-------- Localhost ---------------------------------------------------------------------------------------

   localLegacySquirrelCommonApi:'https://sq3devprojects.albert-ing.com/squirrelAPI/CommonApi',
   localLegacySquirrelV3:'https://sq3devprojects.albert-ing.com/squirrelAPI/SquirrelV3',
 
   // --------------------------------------------------------------------------------------------------------- 
   
 
   //------- Dev-Server --------------------------------------------------------------------------------------
 
   devLegacySquirrelCommonApi:'https://squirrel3developmentprojects.albert-ing.com/squirrelAPI/CommonApi',
   devLegacySquirrelV3:'https://squirrel3developmentprojects.albert-ing.com/squirrelAPI/SquirrelV3',
 
   //--------------------------------------------------------------------------------------------------------
 
   // ------- TestServer1 ----------------------------------------------------------------------------------------
 
   squirreltest1LegacySquirrelCommonApi: 'https://squirreltest1.albert-ing.com/squirrelAPI/CommonApi',
   squirreltest1LegacySquirrelV3: 'https://squirreltest1.albert-ing.com/squirrelAPI/SquirrelV3',
   squirreltest2LegacySquirrelV3: 'https://squirreltest2.albert-ing.com/squirrelAPI/SquirrelV3',
 
   //------------------------------------------------------------------------------------------------------------
 

  openIdConnectSettings: {
    // Kleinschreibung erforderlich: IdentityServer4 liefert den Issuer lowercased
    // (LowerCaseIssuerUri), und angular-auth-oidc-client v21 vergleicht strikt.
    authority: 'https://sq3devbackend.albert-ing.com/identitysts',
    client_id: 'squirrelclientdev',
    response_type: 'code',
    // Muss exakt der im IdentityServer registrierten RedirectUri entsprechen
    // (Live-DB DEV: mit Trailing Slash). Der TrailingSlashUrlSerializer in der
    // App sorgt dafuer, dass die Callback-Route beide Varianten matcht.
    redirect_uri: 'https://sq3dev-r562uh.albert-ing.com/signin-callback/',
    scope: 'openid profile roles projectsmicroservice usersmicroservice documentsmicroservice squirrelfbdbmigrations tenantsmicroservice',
    // post_logout_redirect_uri: 'https://sq3dev-r562uh.albert-ing.com/signin-callback',
    post_logout_redirect_uri: 'https://sq3dev-r562uh.albert-ing.com/',
    automaticSilentRenew: true,
    silent_redirect_uri: 'https://sq3dev-r562uh.albert-ing.com/redirect-silentrenew'
  }
};